<!-- Main content -->
<div class="border-b border-gray-100">
  <div
    class="relative w-full bg-contrast py-base mx-auto px-sm lg:px-lg flex items-center justify-between lg:justify-center lg:block border-b border-gray-100 lg:border-b-0"
  >
    <div
      class="w-[32px] h-[32px] flex items-center justify-center lg:hidden cursor-pointer text-txt"
      (click)="openSideMenuBottomSheet()"
    >
      <svg-icon [key]="isBottomSheetMenuOpen ? 'close-light' : 'menu'" [fontSize]="'20px'"></svg-icon>
    </div>

    <div class="h-[32px] hidden lg:flex items-center">
      @if (showLargeMenu) {
        <div
          (click)="showLargeMenu = !showLargeMenu; showLargeMenuChanged.emit(showLargeMenu)"
          class="h-full w-[100px] group cursor-pointer flex items-center"
        >
          <img src="assets/images/icons/new-big-logo.svg" alt="Logo" />
        </div>
      }
      @if (!showLargeMenu) {
        <div
          (click)="showLargeMenu = !showLargeMenu; showLargeMenuChanged.emit(showLargeMenu)"
          class="h-full w-[100px] flex items-center text-primary cursor-pointer"
        >
          <img src="assets/images/icons/new-logo.svg" alt="Logo" />
        </div>
      }
    </div>

    <img
      class="lg:hidden dark:hidden h-[32px] cursor-pointer"
      src="assets/images/icons/new-big-logo.svg"
      alt="Logo"
      routerLink="/dashboard"
    />

    <img
      class="hidden lg:hidden dark:block h-[32px] cursor-pointer"
      src="assets/images/icons/new-big-logo-darkmode.svg"
      alt="Logo"
      routerLink="/dashboard"
    />

    <div class="lg:absolute lg:top-base lg:right-2xl flex items-center">
      <lla-announcements-menu class="block"></lla-announcements-menu>
    </div>
  </div>
</div>
